export const styles = {
  iconButton: {
    color: 'info.300',
    '&:hover': {
      color: 'neutral.25',
    },
    '& .MuiSvgIcon-root': {
      typography: {
        xs: 'subtitle1',
        md: 'h2',
      },
    },
  },
};
